<div class="wrap flex flex-justify-center flex-middle flex-column-m flex-column-s">
    <div class="c-4 c-12-m c-12-s">
        <div class="overflow-hidden"
             [ngClass]="component?.ratio || 'ratio-1-1'">
            <shell></shell>
            <img [fill]="true"
                 [ratio]="1"
                 [dfImage]="component.firstImage || ''"
                 alt="image">
        </div>
        <p class="c1 p-t-2 col-13 left"
           *iCms="'firstCaption' of component"></p>
    </div>
    <div class="c-4 c-12-m c-12-s">
        @switch (component.variant) {
        @default {
        <div class="left">
            <p class="h2 left m-t-6"
               *iCms="'title' of component"></p>
            <p class="p1 left m-t-7"
               *iCms="'copy' of component"></p>
            <href [link]="component.buttonUrl">
                <button class="m-t-7"
                        [buttonStyle]>
                    <span *iCms="'buttonCopy' of component"></span>
                </button>
            </href>
        </div>
        }
        @case ('image') {
        <div class="overflow-hidden"
             [ngClass]="component?.ratio || 'ratio-1-1'">
            <shell></shell>
            <img [fill]="true"
                 [ratio]="1"
                 [dfImage]="component.secondImage || ''"
                 alt="image">
        </div>
        <p class="c1 p-t-2 col-13 left"
           *iCms="'secondCaption' of component"></p>
        }
        }
    </div>
</div>
